import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework'
import es from 'vuetify/lib/locale/es';


Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { es },
      current: 'es',
    },
    theme: {
      dark:false,
      themes: {
        light: {
          primary:"#273680",
          secondary:"#7B992D",
          accent:"#00a6ce",
          error: '#b71c1c'
        }
      },
    },
    
});